export const renderValue = (value) => {
  if (value) {
    return value;
  } else if (value === 0 || value === "0") {
    return "0";
  } else {
    return "---";
  }
};
